import {
  WSButton,
  WSCard,
  WSFlexBox,
  WSIcon,
  WSList,
  WSTable,
  WSText
} from "@wingspanhq/fe-component-library";

import styles from "./styles.module.scss";
import { openInNewTab } from "../../utils/openInNewTab";
import { WS_LINKS } from "../../../types/wsLinks";

export const WayfinderWidget: React.FC = () => {
  return (
    <WSCard className={styles.wayfinderWidget}>
      <WSList gap="L">
        <WSFlexBox.CenterY>
          <WSIcon name="compass" color="garnet" size="L" mr="XS" />
          <WSText.Paragraph color="garnet" weight="bold">
            Wayfinder
          </WSText.Paragraph>
        </WSFlexBox.CenterY>

        <WSText.ParagraphXs weight="book" color="gray600">
          Wayfinder is Wingspan’s AI assistant. Consider double-checking
          important information for accuracy.
        </WSText.ParagraphXs>

        <WSButton.Link
          className={styles.link}
          rightIcon="open-tab"
          onClick={() => openInNewTab(WS_LINKS.wayfinderAbout)}
        >
          Learn more about Wayfinder
        </WSButton.Link>
      </WSList>
    </WSCard>
  );
};
